import { NotificationApi } from '@linktivity/ars-neo';
import config from './config';

const notificationApi = new NotificationApi(config);

export default notificationApi;
